import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';
import type { BaseButtonProps } from './button.types';

import { getButtonClasses } from './button.styles';

interface UIButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, BaseButtonProps {}

export const UIButton = forwardRef<HTMLButtonElement, UIButtonProps>(
  ({ size = 'medium', variant = 'primary', shape = 'round', disabled = false, className, onClick, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={getButtonClasses(size, variant, shape, disabled, className)}
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          if (disabled) return;

          onClick?.(e);
        }}
        {...props}
      />
    );
  }
);
